"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomIcon = exports.CustomIconArgs = void 0;
var custom_icon_type_enum_1 = require("../../shared/enums/custom-icon-type.enum");
var get_component_1 = require("../../shared/helpers/get-component");
var il_icon_1 = require("../il-icon/il-icon");
// arguments
exports.CustomIconArgs = {
    type: custom_icon_type_enum_1.CustomIconTypeEnum.CALVERT_ELECTIVE,
};
// components
exports.CustomIcon = (0, get_component_1.getComponent)(il_icon_1.ILIcon, exports.CustomIconArgs);
